import { memo } from 'react';
import { Palette } from 'config';
import styled from '@emotion/styled';
import { NotificationIcon } from 'assets/icons';

const Notification = ({ isAdmin, clickAction, appIsPublished }) => {
  return (
    <Container>
      <NotificationIcon />
      {!isAdmin ? (
        <P>
          If your app is not yet published, please contact:{' '}
          <a href='mailto:support@appnext.com' target='_blank' rel='noreferrer'>
            support@appnext.com
          </a>
        </P>
      ) : (
        <>
          {!appIsPublished ? (
            <P>
              If your app is not yet published,{' '}
              <span onClick={() => clickAction(!appIsPublished)}>click here</span>
            </P>
          ) : (
            <P>
              If your app is already published,{' '}
              <span onClick={() => clickAction(!appIsPublished)}>click here</span>
            </P>
          )}
        </>
      )}
    </Container>
  );
};

export default memo(Notification);

const P = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
  a,
  span {
    color: ${Palette.Primary._500};
    text-decoration: none;
    cursor: pointer;
    &:active {
      //to do
    }
  }
`;

const Container = styled.div`
  padding-left: 8px;
  margin-top: 24px;
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: center;
  background: ${Palette.PrimaryGray._000};
  height: 32px;
  border-radius: 4px;
`;
